import { Breadcrumbs, Link, TextField, useTheme } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Collapse from "@material-ui/core/Collapse";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import Autocomplete from "@material-ui/lab/Autocomplete";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import SortableTable from "../../Components/SortableTable";
import Chart from "../../Components/TemperatureChart";
import Title from "../../Components/Title";
import {
  formatChartData,
  formatTimeWithTZOffset,
  getToken,
} from "../../Utils/Common";
import EnvSettings from "../../Utils/EnvSettings";
import { useStyles } from "../../Utils/Styles";
import { showPopupSnackbar } from "../../redux/actions/snackbarActions";
const server = EnvSettings.server;

function formatTransportationData(data) {
  var arr = [];
  data.forEach((element) => {
    arr.push({
      id: element.id,
      startTime: formatTimeWithTZOffset(element.startTime),
      endTime: formatTimeWithTZOffset(element.endTime),
      description: element.description,
      alerts: element.Alerts.length,
    });
  });
  return arr;
}

export default function DeviceDetails(props) {
  const { t } = useTranslation();
  const classes = useStyles();
  const theme = useTheme();
  const [deviceData, setDeviceData] = useState();
  const [deviceConfig, setDeviceConfig] = useState();
  const [transports, setTransports] = useState();
  const [chartData, setChartData] = useState();
  const [editActive, setEditActive] = useState(false);
  const [configEditActive, setConfigEditActive] = useState(false);
  const [configEditText, setConfigEditText] = useState(t("deviceDetails.edit"));
  const [editText, setEditText] = useState(t("deviceDetails.edit"));
  const [companies, setCompanies] = useState();
  const [collapseOverview, setCollapseOverview] = useState(false);
  const [collapseConfig, setCollapseConfig] = useState(false);
  const [collapseData, setCollapseData] = useState(true);
  var selectedDate =
    props.computedMatch.params.select_date ||
    new Date().toISOString().substring(0, 10);
  const [no_sensors, setNoSensors] = useState([1, 2, 3]);

  let ref = React.useRef();
  const dispatch = useDispatch();

  const history = useHistory();

  let getDevicedata = () => {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        token: getToken(),
        deviceid: props.computedMatch.params.device_id,
      }),
    };
    fetch(server + "/get_device_data", requestOptions)
      .then((res) => res.json())
      .then((result) => {
        if (process.env.NODE_ENV !== "production") {
          console.log(result);
        }
        if (result.error) {
          dispatch(showPopupSnackbar(result));
        } else {
          setDeviceData(result.device);
          if (result.device.deviceType === 2) {
            var index = 1;
            var arr = [];
            Object.keys(result.config).forEach((key, value) => {
              if (key.includes("sensor")) {
                if (result.config[key]) {
                  arr.push(index);
                  index++;
                }
              }
            });
            setNoSensors(arr);
          }
          setDeviceConfig(result.config);
        }
      });
  };

  let updateDevice = () => {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        token: getToken(),
        deviceData: {
          ...deviceData,
        },
      }),
    };
    fetch(server + "/edit_device", requestOptions)
      .then((res) => res.json())
      .then((result) => {
        if (process.env.NODE_ENV !== "production") {
          console.log(result);
        }
        dispatch(showPopupSnackbar(result));
        if (!result.error) {
          setEditActive(false);
          setEditText(
            editActive ? t("deviceDetails.edit") : t("deviceDetails.cancel")
          );
        }
      });
  };

  let updateDeviceConfig = () => {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        token: getToken(),
        deviceConfig: {
          ...deviceConfig,
        },
      }),
    };
    fetch(server + "/edit_device_config", requestOptions)
      .then((res) => res.json())
      .then((result) => {
        if (process.env.NODE_ENV !== "production") {
          console.log(result);
        }
        dispatch(showPopupSnackbar(result));
        if (!result.error) {
          setConfigEditActive(false);
          setConfigEditText(
            configEditActive
              ? t("deviceDetails.edit")
              : t("deviceDetails.cancel")
          );
        }
      });
  };

  let addSensor = () => {
    if (no_sensors.length < 15) {
      setNoSensors([...no_sensors, no_sensors.length + 1]);
    }
  };

  let setRowStyle = (data) => {
    if (data.alerts > 0) {
      return {
        backgroundColor: theme.palette.warning.light,
        cursor: "pointer",
      };
    }
    return { cursor: "pointer" };
  };

  let handleRowClick = (data) => {
    history.push("/transports/" + data);
  };

  useEffect(getDevicedata, []);
  useEffect(() => {
    const getCompanies = () => {
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token: getToken() }),
      };
      fetch(server + "/get_companies", requestOptions)
        .then((res) => res.json())
        .then((result) => {
          if (process.env.NODE_ENV !== "production") {
            console.log(result);
          }
          if (result.error) {
            dispatch(showPopupSnackbar(result));
          } else {
            setCompanies(result.companies);
          }
        });
    };

    if (props.computedMatch.url.includes("/cpanel/")) {
      getCompanies();
    }
  }, [props.computedMatch.url, dispatch]);

  useEffect(() => {
    const getTransports = () => {
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          token: getToken(),
          limit: 500,
          deviceid: props.computedMatch.params.device_id,
        }),
      };
      fetch(server + "/get_transportation_list", requestOptions)
        .then((res) => res.json())
        .then((result) => {
          if (process.env.NODE_ENV !== "production") {
            console.log(result);
          }
          if (result.error) {
            dispatch(showPopupSnackbar(result));
          } else {
            setTransports(formatTransportationData(result.transports));
          }
        });
    };

    const getChartData = () => {
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          token: getToken(),
          all_data: true,
          deviceid: props.computedMatch.params.device_id,
          time_period_start: selectedDate + " 00:00:00",
          time_period_end: selectedDate + " 23:59:59",
        }),
      };
      fetch(server + "/get_continuous_data", requestOptions)
        .then((res) => res.json())
        .then((result) => {
          if (process.env.NODE_ENV !== "production") {
            console.log(result);
          }
          if (result.error) {
            if (result.message === "No records found") {
              setChartData(undefined);
            } else {
              dispatch(showPopupSnackbar(result));
            }
          } else {
            setChartData(undefined);
            setChartData(result.devices[0]);
          }
        });
    };

    if (deviceData && deviceData.deviceType === 1 && !transports) {
      getTransports();
    } else if (deviceData && deviceData.deviceType === 2 && !chartData) {
      getChartData();
    }
  }, [
    deviceData,
    transports,
    chartData,
    props.computedMatch.params.device_id,
    dispatch,
    selectedDate,
  ]);

  return (
    <Grid container spacing={3}>
      <Grid item xs>
        {deviceData ? (
          <Breadcrumbs aria-label="breadcrumb">
            <Link color="inherit" href="/devices">
              {t("deviceDetails.devices")}
            </Link>
            <Typography color="textPrimary">{`${
              deviceData
                ? (deviceData.deviceType === 1 ? `Medibag ` : `Sensor `) +
                  deviceData.serialNumber
                : undefined
            }`}</Typography>
          </Breadcrumbs>
        ) : undefined}
      </Grid>
      {deviceData ? (
        <Grid item xs={12}>
          <Paper className={classes.paper}>
            <Collapse in={collapseData} collapsedHeight={40}>
              <Grid container spacing={3} style={{ flexDirection: "row" }}>
                <Grid item>
                  <Button
                    onClick={() => {
                      setCollapseData(!collapseData);
                    }}
                  >
                    {collapseData ? (
                      <ExpandLess></ExpandLess>
                    ) : (
                      <ExpandMore></ExpandMore>
                    )}
                  </Button>
                </Grid>
                <Grid item>
                  <Title>
                    {deviceData.deviceType === 1
                      ? t("deviceDetails.transports")
                      : t("deviceDetails.monitoringGraph")}
                  </Title>
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                {deviceData.deviceType === 1 ? (
                  transports ? (
                    <div style={{ padding: 5, paddingLeft: 10 }}>
                      <SortableTable
                        data={{
                          headCells: [
                            {
                              id: "startTime",
                              numeric: false,
                              disablePadding: true,
                              label: t("transportList.started"),
                            },
                            {
                              id: "endTime",
                              numeric: false,
                              disablePadding: false,
                              label: t("transportList.ended"),
                            },
                            {
                              id: "description",
                              numeric: false,
                              disablePadding: false,
                              label: t("transportList.description"),
                            },
                            {
                              id: "alerts",
                              numeric: false,
                              disablePadding: false,
                              label: t("transportList.alerts"),
                            },
                          ],
                          defaultSortRow: "startTime",
                          handleRowClick: handleRowClick,
                          getRowStyle: setRowStyle,
                          tableData: transports,
                          rowsPerPage: 5,
                        }}
                      />
                    </div>
                  ) : undefined
                ) : chartData ? (
                  <div
                    style={{
                      padding: 25,
                      paddingBottom: 100,
                      height: 450,
                      width: "100%",
                    }}
                  >
                    <Chart
                      data={{
                        chartData: formatChartData(
                          chartData.Measurements
                        ).reverse(),
                        title: chartData.deviceName || chartData.serialNumber,
                        deviceConfig: chartData.DeviceConfig,
                      }}
                    />
                  </div>
                ) : undefined}
              </Grid>
            </Collapse>
          </Paper>

          <Paper className={classes.paper} style={{ marginTop: 30 }}>
            <Collapse in={collapseOverview} collapsedHeight={40}>
              <Grid container spacing={3} style={{ flexDirection: "row" }}>
                <Grid item>
                  <Button
                    onClick={() => {
                      setCollapseOverview(!collapseOverview);
                    }}
                  >
                    {collapseOverview ? (
                      <ExpandLess></ExpandLess>
                    ) : (
                      <ExpandMore></ExpandMore>
                    )}
                  </Button>
                </Grid>
                <Grid item>
                  <Title>{t("deviceDetails.deviceOverview")}</Title>
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    name="serialNumber"
                    variant="outlined"
                    required
                    fullWidth
                    id="serialNumber"
                    label={t("deviceDetails.serial")}
                    disabled
                    value={deviceData?.serialNumber}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    name="deviceType"
                    variant="outlined"
                    required
                    fullWidth
                    id="deviceType"
                    label={t("deviceDetails.type")}
                    disabled={
                      props.computedMatch.url.includes("/cpanel/") && editActive
                        ? false
                        : true
                    }
                    value={
                      props.computedMatch.url.includes("/cpanel/")
                        ? deviceData.deviceType
                        : deviceData.deviceType === 1
                        ? "Medibag"
                        : "Sensor Module"
                    }
                    onChange={(e) => {
                      setDeviceData({
                        ...deviceData,
                        deviceType: e.target.value,
                      });
                    }}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    name="deviceName"
                    variant="outlined"
                    required
                    fullWidth
                    id="deviceName"
                    label={t("deviceDetails.name")}
                    disabled={!editActive}
                    //defaultValue={deviceName}
                    value={deviceData?.deviceName}
                    onChange={(e) => {
                      setDeviceData({
                        ...deviceData,
                        deviceName: e.target.value,
                      });
                    }}
                  />
                </Grid>
                {props.computedMatch.url.includes("/cpanel/") && companies ? (
                  <Grid item xs={12} sm={6}>
                    <Autocomplete
                      id="combo-box"
                      options={companies}
                      defaultValue={deviceData.Company}
                      disabled={!editActive}
                      getOptionLabel={(option) => option.companyName}
                      onChange={(e, n) => {
                        setDeviceData({ ...deviceData, CompanyId: n.id });
                      }}
                      //style={{ width: 300 }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={t("deviceDetails.company")}
                          ref={ref}
                          variant="outlined"
                        />
                      )}
                    />
                  </Grid>
                ) : undefined}
                <Grid item xs={12}>
                  <Button
                    variant="outlined"
                    onClick={() => {
                      setEditActive(editActive ? false : true);
                      setEditText(
                        editActive
                          ? t("deviceDetails.edit")
                          : t("deviceDetails.cancel")
                      );
                    }}
                  >
                    <Typography>{editText}</Typography>
                  </Button>
                  <Button
                    variant="outlined"
                    style={editActive ? undefined : { display: "none" }}
                    onClick={() => {
                      updateDevice();
                    }}
                  >
                    <Typography>{t("deviceDetails.submit")}</Typography>
                  </Button>
                </Grid>
              </Grid>
            </Collapse>
          </Paper>

          <Paper className={classes.paper} style={{ marginTop: 30 }}>
            <Collapse in={collapseConfig} collapsedHeight={40}>
              <Grid container spacing={3} style={{ flexDirection: "row" }}>
                <Grid item>
                  <Button
                    onClick={() => {
                      setCollapseConfig(!collapseConfig);
                    }}
                  >
                    {collapseConfig ? (
                      <ExpandLess></ExpandLess>
                    ) : (
                      <ExpandMore></ExpandMore>
                    )}
                  </Button>
                </Grid>
                <Grid item>
                  <Title>{t("deviceDetails.deviceConfig")}</Title>
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                {deviceData.deviceType === 1 ? (
                  <React.Fragment>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        name="targetTempLow"
                        variant="outlined"
                        required
                        fullWidth
                        type="number"
                        id="targetTempLow"
                        label={t("deviceDetails.targetTempLow")}
                        disabled={!configEditActive}
                        value={deviceConfig?.targetTempLow}
                        onChange={(e) => {
                          setDeviceConfig({
                            ...deviceConfig,
                            targetTempLow: e.target.value,
                          });
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        name="targetTempHigh"
                        variant="outlined"
                        required
                        fullWidth
                        type="number"
                        id="targetTempHigh"
                        label={t("deviceDetails.targetTempHigh")}
                        disabled={!configEditActive}
                        value={deviceConfig?.targetTempHigh}
                        onChange={(e) => {
                          setDeviceConfig({
                            ...deviceConfig,
                            targetTempHigh: e.target.value,
                          });
                        }}
                      />
                    </Grid>
                  </React.Fragment>
                ) : undefined}
                {no_sensors.map((idx) => (
                  <Grid item xs={12}>
                    <Grid container spacing={3}>
                      <Grid item>
                        <Typography>
                          {t("deviceDetails.sensor") + idx}{" "}
                        </Typography>
                      </Grid>
                      <Grid item>
                        <TextField
                          name="sensorId"
                          variant="outlined"
                          required
                          id={"sensorId" + idx}
                          label={t("deviceDetails.id")}
                          disabled={!configEditActive}
                          value={
                            deviceConfig
                              ? deviceConfig["sensor" + idx]?.id
                              : undefined
                          }
                          onChange={(e) => {
                            setDeviceConfig({
                              ...deviceConfig,
                              [`sensor${idx}`]: {
                                ...deviceConfig[`sensor${idx}`],
                                id: e.target.value,
                              },
                            });
                          }}
                        />
                      </Grid>
                      <Grid item>
                        <TextField
                          name="sensorName"
                          variant="outlined"
                          required
                          id={"sensorName" + idx}
                          label={t("deviceDetails.name")}
                          disabled={!configEditActive}
                          value={
                            deviceConfig
                              ? deviceConfig["sensor" + idx]?.name
                              : undefined
                          }
                          onChange={(e) => {
                            setDeviceConfig({
                              ...deviceConfig,
                              [`sensor${idx}`]: {
                                ...deviceConfig[`sensor${idx}`],
                                name: e.target.value,
                              },
                            });
                          }}
                        />
                      </Grid>
                      <Grid item>
                        <TextField
                          name="alertTempLow"
                          variant="outlined"
                          required
                          type="number"
                          id={"alertTempLow" + idx}
                          label={t("deviceDetails.alertTempLow")}
                          disabled={!configEditActive}
                          value={
                            deviceConfig
                              ? deviceConfig["sensor" + idx]?.alertLow
                              : undefined
                          }
                          onChange={(e) => {
                            setDeviceConfig({
                              ...deviceConfig,
                              [`sensor${idx}`]: {
                                ...deviceConfig[`sensor${idx}`],
                                alertLow: e.target.value,
                              },
                            });
                          }}
                        />
                      </Grid>
                      <Grid item>
                        <TextField
                          name="alertTempHigh"
                          variant="outlined"
                          required
                          type="number"
                          id={"alertTempHigh" + idx}
                          label={t("deviceDetails.alertTempHigh")}
                          disabled={!configEditActive}
                          value={
                            deviceConfig
                              ? deviceConfig["sensor" + idx]?.alertHigh
                              : undefined
                          }
                          onChange={(e) => {
                            setDeviceConfig({
                              ...deviceConfig,
                              [`sensor${idx}`]: {
                                ...deviceConfig[`sensor${idx}`],
                                alertHigh: e.target.value,
                              },
                            });
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                ))}
                <Grid item xs={12}>
                  <Button
                    variant="outlined"
                    onClick={() => {
                      setConfigEditActive(!configEditActive);
                      setConfigEditText(
                        configEditActive
                          ? t("deviceDetails.edit")
                          : t("deviceDetails.cancel")
                      );
                    }}
                  >
                    <Typography>{configEditText}</Typography>
                  </Button>
                  <Button
                    variant="outlined"
                    style={configEditActive ? undefined : { display: "none" }}
                    onClick={addSensor}
                  >
                    <Typography>{t("deviceDetails.addSensor")}</Typography>
                  </Button>
                  <Button
                    variant="outlined"
                    style={configEditActive ? undefined : { display: "none" }}
                    onClick={() => {
                      updateDeviceConfig();
                    }}
                  >
                    <Typography>{t("deviceDetails.submit")}</Typography>
                  </Button>
                </Grid>
              </Grid>
            </Collapse>
          </Paper>
        </Grid>
      ) : undefined}

      {/* Latest data */}
    </Grid>
  );
}
